import "./heroPlanet.scss";
import * as utils from "shell/app/app.utils";
import { useLayoutEffect, useRef } from "react";

interface heroProps {}

const HeroPlanet: React.FC<heroProps> = (props) => {
  const elRef = useRef<HTMLDivElement>(null);
  const aFrame = useRef<any>(0);

  useLayoutEffect(() => {
    const render = () => {
      const progress = window.rcScrollY / (window.innerHeight * 0.4);
      const progressClamp = utils.clamp(progress);

      if (elRef.current) {
        elRef.current.style.setProperty("--progress", progressClamp.toFixed(8));
      }
      aFrame.current = requestAnimationFrame(render);
    };
    //
    aFrame.current = requestAnimationFrame(render);
    return () => cancelAnimationFrame(aFrame.current);
  }, []);

  return (
    <div className="hero-planet" ref={elRef}>
      <div className="hero-planet__planet">        
        <img src={utils.assetPath(`/images/hero-planet${window.innerWidth < 980 ? '-mobile' : ''}.png`)} alt="" className="is-desktop" />
      </div>
      <div className="hero-planet__gradient" />
    </div>
  );
};

export default HeroPlanet;
